import type { OrchestratedQueryStore } from "@/domains/library"
import { IEventBus } from "@/domains/events"

import type { IEpochGraphQlService } from "./interfaces"
import { EpochGraphQlTransport } from "./epoch-graphql-transport"
import { EpochOrchestratorFactory } from "./epoch-orchestrator-factory"
import { EpochRepository } from "./epoch-repository"
import { EpochsPageStore } from "./epochs-page-store"

export type EpochNamespace = {
  Repository: EpochRepository
  Orchestrator: ReturnType<typeof EpochOrchestratorFactory.create>
  PageStore: EpochsPageStore
}

export type EpochNamespaceFactoryParams = {
  graphQlService: IEpochGraphQlService
  orchestratedQueryStore: OrchestratedQueryStore
  eventBus: IEventBus
}

export const EpochNamespaceFactory = {
  create(params: EpochNamespaceFactoryParams): EpochNamespace {
    const { graphQlService, orchestratedQueryStore, eventBus } = params

    // Create transport
    const graphQlTransport = new EpochGraphQlTransport(graphQlService)

    // Create repository
    const repository = new EpochRepository(eventBus)

    // Create orchestrator
    const orchestrator = EpochOrchestratorFactory.create(
      graphQlTransport,
      repository,
      orchestratedQueryStore,
      eventBus,
    )

    // Create page store
    const pageStore = new EpochsPageStore(repository, orchestrator)

    return {
      Repository: repository,
      Orchestrator: orchestrator,
      PageStore: pageStore,
    }
  },
}
